<template>
  <div class="post-open-state">
    <!-- COMMENT AREA -->
    <div
      class="extended-textarea comment-area"
      role="textbox"
      ref="inputBox"
      id="inputArea"
      @input="getInput"
      contenteditable="true"
      spellcheck="false"
    ></div>

    <!-- ATTACHMENT AREA  -->
    <div
      class="
        attachment-area
        position-relative
        w-100
        mx-auto
        overflow-hidden
        rounded-5
      "
      v-if="uploaded_photo"
    >
      <img v-lazy="uploaded_photo" class="w-100 rounded-5" alt />

      <!-- CLOSE  -->
      <div class="clear-image brand_inverse_light_bg" @click="emptyAttachment">
        <div class="wrapper position-relative w-100 h-100">
          <div class="icon icon-close brand_navy"></div>
        </div>
      </div>
    </div>

    <!-- TOOLBAR  -->
    <div class="toolbar brand_inverse_light_bg">
      <!-- TOOL COLUMN  -->
      <div class="tool-column">
        <!-- ATTACH ICON  -->
        <label class="avatar" for="attachment">
          <input
            type="file"
            id="attachment"
            accept=".png, .jpg, .jpeg"
            hidden
            ref="fileInput"
            @change="uploadAttachment"
          />
          <div class="icon icon-image" title="Attachment"></div>
        </label>
      </div>

      <!-- BUTTON COLUMN  -->
      <div class="button-column">
        <!-- CLEAR  -->
        <div class="avatar" @click="closeComment">
          <div class="icon icon-empty-trash" title="Clear and Close"></div>
        </div>

        <!-- DIVIDER  -->
        <div class="divider"></div>

        <!-- COMMENT BTN  -->
        <button
          class="btn btn-accent z-depth-0"
          ref="postBtn"
          :disabled="isDisabled"
          @click="postComment"
        >
          Post
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "CommentInputOpenState",

  props: {
    postId: Number,
  },

  computed: {
    isDisabled() {
      if (this.comment) {
        if (this.uploaded_photo) {
          return this.photo_url ? false : true;
        } else return false;
      } else return true;
    },
  },

  data: () => ({
    comment: null,
    uploaded_photo: "",
    photo_url: "",

    posting: false,
  }),

  methods: {
    ...mapActions(["uploadToBucket", "deleteFromBucket", "commentOnPost"]),

    postComment() {
      this.$refs.postBtn.disabled = true;
      this.$refs.postBtn.innerText = "Posting..";

      let payload = {
        id: this.postId,
        comment: this.comment.trim(),
        attachment: this.photo_url,
      };

      this.commentOnPost(payload)
        .then((response) => {
          //   console.log(response);

          if (response.data.code === 200) {
            this.$refs.postBtn.disabled = false;
            this.$refs.postBtn.innerText = "Post";

            this.$bus.$emit("addComment", response.data.data);
            this.$bus.$emit("increaseComment");

            setTimeout(() => this.$emit("switchState"), 1000);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$refs.postBtn.disabled = false;
          this.$refs.postBtn.innerText = "Post";
        });
    },

    getInput() {
      this.comment = document.getElementById("inputArea").innerHTML;
    },

    uploadAttachment($event) {
      let file = $event.target.files[0];

      let valid_types = ["png", "jpg", "jpeg"];
      let file_type = file.type.split("/")[1];

      if (valid_types.indexOf(file_type) !== -1) {
        if (file.size < 20000000) {
          let reader = new FileReader();
          reader.onload = (evt) => {
            this.uploaded_photo = evt.target.result;
            this.$refs.fileInput.value = "";

            if (this.uploaded_photo) this.sendPhotoToBucket(file);
          };
          reader.readAsDataURL(file);
        }
      }
    },

    sendPhotoToBucket(file) {
      let file_data = {
        folder: "files/image",
        file,
        base64: false,
      };

      this.uploadToBucket(file_data)
        .then((response) => {
          //   console.log(response);
          this.photo_url = response.data.ObjectURL;
        })
        .catch((err) => console.log(err));
    },

    emptyAttachment() {
      this.uploaded_photo = "";
      this.photo_url ? this.deleteFromBucket(this.photo_url) : null;
    },

    closeComment() {
      this.comment = "";
      this.emptyAttachment();
      this.$emit("switchState");
    },
  },
};
</script>

<style lang="scss" scoped>
@function toRem($size) {
  @return #{$size/16}rem;
}

@mixin font-height($size, $height) {
  font-size: toRem($size);
  line-height: toRem($height);
}

.post-open-state {
  transition: all 0.4s ease-in-out;
  .extended-textarea[contenteditable] {
    &:empty {
      &::before {
        content: "Write a comment here...";
        color: $border-grey-dark;
      }
    }
  }

  .extended-textarea {
    @include font-height(13, 19);
    margin-bottom: toRem(8);
    color: $brand_black;
    width: 100%;
    cursor: text;
    min-height: toRem(55);
    height: auto;
    border: none;
    outline: none;
    word-wrap: break-word;
    white-space: pre-wrap;
    padding: toRem(10) toRem(10) toRem(5);

    @include breakpoint_max(xl) {
      @include font-height(13, 19);
    }

    @include breakpoint_max(xs) {
      @include font-height(12, 18);
    }

    @include breakpoint-custom_max(360) {
      @include font-height(12, 17);
    }

    a {
      color: $brand_inverse !important;
    }
  }

  .attachment-area {
    position: relative;
    padding: toRem(5) toRem(6) 0;
    min-height: toRem(220);
    height: auto;
    max-height: toRem(250);
    width: 100%;
    margin-bottom: toRem(8);
    background-position: center center;
    text-align: center;
    vertical-align: middle;

    img {
      display: table-cell;
      vertical-align: middle;
    }

    .clear-image {
      position: absolute;
      border-radius: 50%;
      top: toRem(12);
      right: toRem(12);
      cursor: pointer;
      @include equal_min_edge(26);
      z-index: 9;
      transition: all 0.4s ease-in-out;

      .icon {
        position: absolute;
        @include transform_center;
        font-size: toRem(13);
      }

      &:hover {
        background: $brand_accent_light !important;
      }
    }
  }

  .toolbar {
    @include flex_row_between_nowrap;
    padding: 0 toRem(10);

    @include breakpoint_max(xs) {
      padding: toRem(5) toRem(6);
    }

    .tool-column {
      @include flex_row_start_nowrap;
    }

    .button-column {
      @include flex_row_end_nowrap;

      .btn {
        padding: toRem(8) toRem(16);
        font-size: toRem(10);

        @include breakpoint_max(xs) {
          padding: toRem(7) toRem(14);
          font-size: toRem(8.5);
        }
      }
    }

    .avatar {
      @include equal_min_edge(26);

      @include breakpoint_max(xs) {
        @include equal_min_edge(24);
      }

      .icon {
        @include transform-center;
        transition: all 0.4s ease-in-out;
        font-size: toRem(20);
        color: $color_grey_dark;
        cursor: pointer;

        @include breakpoint_max(xs) {
          font-size: toRem(18);
        }

        &:hover {
          color: darken($brand_accent, 5%);
        }
      }

      .selected {
        color: darken($brand_accent, 5%);
      }

      .icon-paper-clip {
        font-size: toRem(18);

        @include breakpoint_max(xs) {
          font-size: toRem(16);
        }
      }

      .icon-empty-trash {
        font-size: toRem(18);

        @include breakpoint_max(xs) {
          font-size: toRem(18.5);
        }

        &:hover {
          color: $brand_red;
        }
      }
    }

    .divider {
      width: toRem(1);
      height: toRem(22);
      background: $border_grey;
      margin: 0 toRem(9);

      @include breakpoint_max(xs) {
        margin: 0 toRem(5);
      }
    }

    .btn {
      padding: toRem(10) toRem(15) !important;
      min-width: toRem(70);
      width: auto;
      max-width: toRem(90);
      font-size: toRem(10.5);
    }
  }
}
</style>
